import React from 'react';
import { motion } from 'framer-motion';
import { PLACEMENT } from '../data/content';
import {
  FileText,
  Linkedin,
  Users,
  BotMessageSquare,
  Briefcase,
  LifeBuoy,
} from 'lucide-react';

const ICONS = { FileText, Linkedin, Users, BotMessageSquare, Briefcase, LifeBuoy };

export default function Placement() {
  return (
    <section id="placement" className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{PLACEMENT.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {PLACEMENT.title}
            <span className="grad-text-red">{PLACEMENT.titleAccent}</span>
          </h2>
          <p className="mt-6 text-[16px] text-[color:var(--muted)] leading-relaxed">{PLACEMENT.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PLACEMENT.cards.map((c, i) => {
            const Icon = ICONS[c.icon] || Briefcase;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="card-lift bg-white border border-line rounded-2xl p-7"
              >
                <div className="w-11 h-11 rounded-xl bg-red-soft flex items-center justify-center">
                  <Icon size={20} className="text-red" />
                </div>
                <div className="mt-5 font-display text-[20px]">{c.title}</div>
                <p className="mt-3 text-[14.5px] text-[color:var(--muted)] leading-relaxed">{c.body}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Timeline */}
        <div className="mt-20">
          <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-[color:var(--muted)] mb-8">
            How placement works
          </div>
          <div className="relative">
            <div className="absolute top-6 left-6 right-6 h-px bg-line hidden md:block" />
            <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
              {PLACEMENT.timeline.map((t, i) => (
                <motion.div
                  key={t.n}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="relative flex flex-col items-center text-center"
                >
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center font-display text-white z-10 ${
                      i === PLACEMENT.timeline.length - 1 ? 'bg-red' : 'bg-navy'
                    }`}
                  >
                    {t.n}
                  </div>
                  <div className="mt-4 font-display text-[17px]">{t.title}</div>
                  <div className="mt-1 text-[12.5px] text-[color:var(--muted)]">{t.sub}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
